import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import SsoCallbackView from '../views/SsoCallbackView.vue';
import MfaSetupView from '../views/MfaSetupView.vue';
import MfaVerifyView from '../views/MfaVerifyView.vue';
import NotFoundView from '../views/NotFoundView.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
    },
    {
        // Where Cognito lands after the customer's IdP authenticates the admin (CM-1805). The path
        // is registered as the app client's redirect_uri and matched exactly, so it must not move
        // without changing callback_url_host in terragrunt to match.
        //
        // Reached cold, as an external navigation, never by in-app routing — so the server must
        // serve index.html here, the same rewrite /login already relies on.
        path: '/login/sso/callback',
        name: 'sso-callback',
        component: SsoCallbackView,
    },
    {
        path: '/mfa/otp/new',
        name: 'mfa-otp-new',
        component: MfaSetupView,
    },
    {
        path: '/mfa/otp/verify',
        name: 'mfa-otp-verify',
        component: MfaVerifyView,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: NotFoundView,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
